export const PRODUCT_QUANTITY_PRECISION = 3;
export const STOCK_QUANTITY_PRECISION = 3;
